export default {
  flashSalesTitle: {
    id: 'flash_sales_product_page_title_tag',
    defaultMessage: 'Get {price} off with limited Flash Deal',
  },
  flashSalesDescription: {
    id: 'flash_sales_product_page_description_tag',
    defaultMessage: 'Automatically applied at checkout.',
  },
  sellerFlashSalesTitle: {
    id: 'seller_flash_sales_product_page_title_tag',
    defaultMessage: 'Deals available',
  },
  sellerFlashSalesDescription: {
    id: 'seller_flash_sales_product_page_description_tag',
    defaultMessage: 'Check out our best offers',
  },
  sellerFlashSalesButtonLabel: {
    id: 'seller_flash_sales_product_page_cta_tag',
    defaultMessage: 'View',
  },
} as const
